// import toothImage9 from "./tooth-images/tooth_image_9";
// import toothImage10 from "./tooth-images/tooth_image_10";
// import toothImage13 from "./tooth-images/tooth_image_13";
// import toothImage15 from "./tooth-images/tooth_image_15";
// import toothImage19 from "./tooth-images/tooth_image_19";
// import toothImage26 from "./tooth-images/tooth_image_26";
// import toothImage301 from "./tooth-images/tooth_image_301";
// import toothImage318 from "./tooth-images/tooth_image_318";
// import toothImage300_gum from "./tooth-images/tooth_image_300_gum";
//
// const imgProvider = {
//     "9": toothImage9,
//     "10": toothImage10,
//     "13": toothImage13,
//     "15": toothImage15,
//     "19": toothImage19,
//     "26": toothImage26,
//     "301": toothImage301,
//     "318": toothImage318,
//     "300_gum": toothImage300_gum,
// };

import toothImage320 from "./tooth-images/tooth_image_320";

const ImageSrcProvider = {

    noImage: function() {
        return('data:image/gif;base64,R0lGODlhPwB2AJEAAAAAAP///////wAAACH5BAEAAAIALAAAAAA/AHYAAAJglI+py+0Po5y02ouz3rz7D4biSJbmiabqyrbuC8fyTNf2jef6zvf+DwwKh8Si8YhMKpfMpvMJjUqn1Kr1is1qt9yu9wsOi8fksvmMTqvX7Lb7DY/L5/S6/Y7P6/f8fq4AADs=');
    },

    getImage: function(src) {
        try {
            if (typeof window.ToothImagesJson === 'object') {
                if (!window.ToothImagesJson.hasOwnProperty('320')) window.ToothImagesJson["320"] = toothImage320;
            }

            // Split src to parts: /10/11.png -> state / tooth
            // handle 300/extra_medium_wide/toothId

            src = src.replace("300/extra_medium_wide", "300_gum");

            const data = src.replace("/images/smart/", "").split("/");
            if (data.length !== 2) return src;

            let stateId = String(data[0]);
            if (stateId === "300") stateId = "9";
            const toothId = String(data[1]).replace(".png","");

            if (!window.hasOwnProperty('ToothImagesJson')) return src;
            if (!window.ToothImagesJson.hasOwnProperty(stateId)) return src;
            if (!window.ToothImagesJson[stateId].hasOwnProperty(toothId)) return src;

            return 'data:image/png;base64,' + window.ToothImagesJson[stateId][toothId];
        } catch(error) {
            captureException(error);
            return src;
        }
    },
};

export default ImageSrcProvider;
